// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9e8a9d84","51":"6ec5cb3b","89":"02c57e3c","208":"69433531","336":"ad197bf9","687":"04eaf574","739":"d0bebe89","741":"cb954701","760":"7debd9be","774":"e0d30823","883":"72f23795"}[chunkId] + ".chunk.js";
};